export enum MultiplierType {
    NoMultiplier = 0,
    Dollar = 1,
    Percentage = 2
}
